<template>
  <div class="home_index" ref="home_index">
    
    <div class="index_box">
      <div class="recommend_box">
        <div class="recommend_tit">推荐</div>
        <!-- <div class="recommend_k">
          <div class="recommend_k_tit">生活服务</div>
          <van-grid :border="false" :column-num="4">
            <van-grid-item url="https://engine.bigabccba.com/index/activity?appKey=3LW5HFJm3fQdw6N6hNpB71QYxjfM&adslotId=390590&uk_a1=__IMEI__&uk_a2=__IMEI2__&uk_a3=__MUID__&uk_b1=__IDFA__&uk_b2=__IDFA2__&uk_c1=__OAID__">
              <van-image src="/public/recommend/icon_1.png" />
              红包猎手
            </van-grid-item>
            <van-grid-item url="https://www.gzuni.com/apps/kingcard/b2i/xsg_page/?id=yb&flag=s&card=dwk">
              <van-image src="/public/recommend/icon_2.png" />
              大王卡
            </van-grid-item>
            <van-grid-item url="https://smarthome.17wo.cn/wonetplan/yInaY/GDLT">
              <van-image src="/public/recommend/icon_2.png" />
              美食卡
            </van-grid-item>
            <van-grid-item url="https://squirrel.kxbwmedia.com/ditch/task?union_id=10237">
              <van-image src="/public/recommend/icon_4.png" />
              点点赚
            </van-grid-item>
            <van-grid-item url="https://ares.nb.qq.com/dist/ares.html?PageID=6827917126251155456&PackageID=6762962926954364928">
              <van-image src="/public/recommend/icon_5.png" />
              小鹅拼拼
            </van-grid-item>
            <van-grid-item url="http://s2.klafxiang.com/index.php/web/waifang/wkhd40">
              <van-image src="/public/recommend/icon_6.png" />
              天天抽奖
            </van-grid-item> 
            <van-grid-item url="http://priv.icmad.cn/pages/modules/hf/index/hfczfou">
              <van-image src="/public/recommend/icon_7.png" />
              话费优惠
            </van-grid-item>
            <van-grid-item url="https://www.xiaoyudingzhi.com/h5/#/landpage?chanCode=L6iuOpTUcN973vGBc7rF">
              <van-image src="/public/recommend/icon_8.png" />
              小鱼定制
            </van-grid-item>
          </van-grid>
        </div> -->
        <div class="recommend_k" v-for="(recommend_tit, index) in recommendData" :key="index">
          <div class="recommend_k_tit">{{index}}</div>
          <van-grid :border="false" :column-num="4">
            <van-grid-item :url="recommend_list.url"  v-for="(recommend_list, indexs) in recommend_tit" :key="indexs">
              <van-image :src="recommend_list.image" />
              {{recommend_list.title}}
            </van-grid-item>
          </van-grid>
        </div>
      </div>
    </div>
    <tab-bar :current-index="1" />
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import API from "../api";
import axios from "axios";
import qs from 'qs';
import TabBar from '../components/tabbar.vue';
// import { Message } from 'element-ui'
import {
  Popup as VanPopup,
  Image as VanImage,
  Grid as VanGrid,
  GridItem as VanGridItem,
  Toast
} from 'vant';
export default {
  name: "",
  
  components: {
   TabBar,
   VanImage,
   VanPopup,
   VanGrid,
   VanGridItem,
  },
  data() {
    return {
      recommendData:{},
    };
  },
  mounted() {
    this.getRecommendList();
  },
  
  methods: {
    //获取广告图
    async getRecommendList(){
      const res = await API.getRecommendList();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.recommendData = res.data.data;
        // console.log(this.recommendData)
      } else {
        Toast(res.data.message);
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// recommend.vue?564e66a3